import React, {useState} from 'react';
import {gql} from "apollo-boost";
import client from '../../src/graphql/client';
import {get} from 'lodash';
import styled from 'styled-components';
import {theme} from '../../src/themes/default-theme';

import Icon from '../../src/assets/icons/speech-circle.svg';
import seoQuery from '../../src/graphql/queries/seo';
import contentBuilderQuery from '../../src/graphql/queries/content-builder';
import refactorHb from '../../src/data-restructure/multimedia/hero-banner';
import refactorHBCData from '../../src/data-restructure/multimedia/hero-banner-carousel';
import refactorBreadcrumbsData from '../../src/data-restructure/navigation/breadcrumbs/breadcrumbs';

// components
import FormContainer from '../../src/containers/Forms/FormContainer';
import Banner from '../../src/components/multimedia/Banner';
import BannerSlider from '../../src/components/multimedia/BannerSlider';

const FormWrapper = styled.div`
  ${props => props.hb === 0 && `
    ${theme.props.desktopNavUp} {
      margin-top: 100px;
    }
  `}
`

const Enquiry = (props) => {

  const country = props.countryProps.countryCode === 'AU' ? "Australia's" : "New Zealand's"

  const dealerTitle = process.browser && process.env.DEALER_SITE ? window.staticly.dealerData.name : "{{data.template.dealer.name}}"

  const [formState, setFormState] = useState({});

  const handleChange = (state) => {
    setFormState(state);
  }

  return (
    <>
      {props.heroBanner &&
        <Banner
          {...props.heroBanner}
          largePaddingTop={true}
        />
      }
      {props.heroBannerSlider &&
        <BannerSlider
          {...props.heroBannerSlider}
        />
      }

      <FormWrapper hb={props.heroBanner || props.heroBannerSlider ? 1 : 0}>
        <FormContainer
          icon={Icon}
          thankYouUrl="/enquiry/thank-you"
          formId="enquiry"
          title="TALK TO OUR TEAM.<br />WE'RE HERE TO HELP"
          text="Jayco strives to provide the best service possible with every contact. We value your comments and feedback. Got a comment, question or request? Get in touch with one of our Jayco experts today."
          onChange={handleChange}
          formItems={[
            {
              type: 'name',
              name: 'first_name',
              label: 'first_name',
              placeholder: 'First name*',
              errorText: 'This field is required',
              required: true
            },
            {
              type: 'name',
              name: 'last_name',
              label: 'last_name',
              placeholder: 'Last name*',
              errorText: 'This field is required',
              required: true
            },
            {
              type: 'email',
              name: 'email',
              label: 'email',
              placeholder: 'Email*',
              errorText: 'Please add a valid email address',
              required: true
            },
            {
              type: 'phone',
              name: 'phone',
              label: 'phone',
              placeholder: 'Contact Number*',
              errorText: 'Please add a 9 digit phone number',
              required: true
            },
            {
              type: 'postcode',
              name: 'postcode',
              label: 'postcode',
              placeholder: 'Postcode*',
              errorText: 'Please add a 4 digit postcode',
              required: true
            },
            {
              type: 'select',
              name: 'enquiry_type',
              label: 'Nature of your enquiry*',
              required: true,
              errorText: 'This field is required',
              options: [{
                optionValue: 'Warranty',
                label: 'Warranty'
              },{
                optionValue: 'Service & Parts',
                label: 'Service & Parts'
              },{
                optionValue: 'Sales enquiry',
                label: 'Sales enquiry'
              },{
                optionValue: 'Technical Enquiry',
                label: 'Technical Enquiry'
              },{
                optionValue: 'Change of ownership',
                label: 'Change of ownership'
              },{
                optionValue: 'Other',
                label: 'Other'
              }]
            },
            {
              type: 'input',
              name: 'chassis',
              label: 'chassis',
              placeholder: 'Chassis',
              errorText: 'This field is required'
            },
            {
              type: 'textarea',
              name: 'comments',
              label: 'Your enquiry',
              placeholder: 'Your enquiry:',
              // errorText: 'This field is required',
              rows: 5,
              // required: true
            },
            {
              type: 'checkbox',
              margin: 'none',
              name: 'e_newsletter',
              label: `Sign me up for ${process.env.DEALER_SITE ? `${dealerTitle}'s` : `Jayco ${country}`} e-Newsletter`,
            },
            {
              type: 'checkbox',
              margin: 'none',
              name: 'privacy',
              label: `I have read and agree to ${process.env.DEALER_SITE ? `${dealerTitle}'s` : `Jayco ${country}`} <a href="/privacy" target="_blank">Privacy Policy</a>*`,
              errorText: 'This field is required',
              required: true
            }
          ]}
        />
      </FormWrapper>
    </>
  )
}
  
Enquiry.propTypes = {

}
  
Enquiry.defaultProps = {

}

export async function getStaticProps() {
  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE : process.env.COUNTRY_CODE;

  const GET_CB_DATA = gql`
    query GET_CB_DATA {
      pageBy(uri: "enquiry?${countryCode.toLowerCase()}") {
        title
        seo {
          ${seoQuery}
        }
        ${contentBuilderQuery()}
        acf_domains {
          assignedDomains
        }
      }
    }
  `

  const result = await client.query({
    query: GET_CB_DATA,
  });

  const context = get(result, 'data.pageBy', {});
  const cbData = get(result, 'data.pageBy.acf_content_builder.contentBuilder', null);

  // Hero banner
  const hasBanner = get(cbData, '[0].fieldGroupName', '') === 'page_AcfContentBuilder_ContentBuilder_FcSingleHeroBanner';
  const heroBanner = hasBanner ? refactorHb(cbData[0]) : null;

  // Banner carousel
  const hasCarousel = get(cbData, '[0].fieldGroupName', '') === 'page_AcfContentBuilder_ContentBuilder_FcHeroBannerCarousel';
  const heroBannerCarousel = hasCarousel ? refactorHBCData(cbData[0]) : null;

  const assignedDomains = get(result, 'data.pageBy.acf_domains.assignedDomains', []); 

  return {
    props: {
      meta: {
        title: context.title,
        seo: context.seo,
        assignedDomains
      },
      breadcrumbs: await refactorBreadcrumbsData('/enquiry', assignedDomains),
      heroBanner,
      heroBannerCarousel,
    }
  }
}
  
export default Enquiry